<div class="bm--auth-form-box edit-profile-page__form">
  <p class="edit-profile-page__title">Change Password</p>
  <bmcore-update-password-form></bmcore-update-password-form>
</div>

<div class="bm--auth-form-box edit-profile-page__form">
  <p class="edit-profile-page__title">Change Email</p>
  <bmcore-update-email-form></bmcore-update-email-form>
</div>
